// Copia espejo de functions/_app/lib/validadores.ts — validación de
// documento de identidad por tipo de persona, usada hoy solo por Partes.
import type { TipoPersona } from "../../shared/types";

export function validarDocumento(
  tipoPersona: TipoPersona,
  documento: string | null | undefined,
): { valido: true } | { valido: false; mensaje: string } {
  if (!documento?.trim()) return { valido: true };
  const soloDigitos = documento.replace(/[^0-9]/g, "");

  if (tipoPersona === "Persona Humana") {
    if (soloDigitos.length < 7 || soloDigitos.length > 8) {
      return { valido: false, mensaje: "El DNI debe tener 7 u 8 dígitos." };
    }
    return { valido: true };
  }

  if (soloDigitos.length !== 11) {
    return { valido: false, mensaje: "El CUIT debe tener 11 dígitos." };
  }
  return { valido: true };
}
